var _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _ellipse2, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluecircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    fill: "#3F5497",
    fillOpacity: 0.23
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.0133,
    cy: 75.9998,
    r: 70.1539,
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.0397,
    cy: 72.4918,
    r: 58.4616,
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1935,
    cy: 66.6456,
    r: 52.6154,
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7693,
    cy: 72.6594,
    r: 46.7693,
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.0769,
    cy: 72.8132,
    rx: 35.0769,
    ry: 40.9231,
    fill: "#3F5497",
    fillOpacity: 0.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3846,
    cy: 77.1722,
    rx: 23.3846,
    ry: 27.2821,
    fill: "#3F5497",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2023_23714)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91.5385,
    cy: 84.4286,
    r: 17.5385,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2023_23714)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.6923,
    cy: 82.5825,
    r: 11.6923,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2023_23714)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.7692,
    cy: 83.6594,
    r: 8.76924,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2023_23714)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.8462,
    cy: 86.7363,
    r: 5.84616,
    fill: "#E5E5E5",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2023_23714",
    x: 70,
    y: 62.8901,
    width: 43.0781,
    height: 43.0769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23714"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2023_23714",
    x: 74,
    y: 66.8901,
    width: 31.3828,
    height: 31.3846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23714"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2023_23714",
    x: 77,
    y: 70.8901,
    width: 25.5391,
    height: 25.5385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23714"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2023_23714",
    x: 83,
    y: 76.8901,
    width: 19.6914,
    height: 19.6923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2023_23714"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecircle);
export default __webpack_public_path__ + "static/media/Blue circle.77b7982d0d38dbcebd8a623bc18b1aed.svg";
export { ForwardRef as ReactComponent };